import { useState } from "react";

function useRecaptchaV2Hook() {
    const [ showV2Captcha, setShowV2Captcha ] = useState(false);
    const clientKeyV2 = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_V2_KEY;

    return {
        showV2Captcha,
        setShowV2Captcha,
        clientKeyV2
    }

}

export default useRecaptchaV2Hook